import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";

import { Calendar, Space, Button, Spin } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import { all as AllStats } from "../../api/Stats";
import { defineColor } from '../../utils';

const MonthTab = forwardRef((props, ref) => {
  const { selectedDate, careUnitIds } = props;

  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState([]);

  const [promise, setPromise] = useState(null);

  /**
   *
   * @param {*} date
   */
  const getDatesMonth = (date) => {
    const startDate = date.clone().startOf('month').startOf('isoWeek');
    const endDate = startDate.clone().add(41, 'days');
    return { startDate, endDate };
  }

  /**
   *
   * @param {*} startDate
   * @param {*} endDate
   */
  const loadStats = (startDate, endDate) => {
    setLoading(true);

    if (promise) {
        promise.cancel();
    }

    let promiseStats = getPromiseStats(startDate, endDate);
    setPromise(promiseStats);

    promiseStats.then((data) => {
      data['stats']['stats'].map((statOfDay) => {
        statOfDay['className'] = defineColor(statOfDay['occupancy_rate']);
        return statOfDay;
      })

      setStats(data['stats']['stats']);
      setPromise(null);
      setLoading(false);
    }).catch(() => {
        setTimeout(() => {
            setLoading(false);
        }, 20000);
    });
  }

  /**
   *
   * @param {*} startDate
   * @param {*} endDate
   */
  const getPromiseStats = (startDate, endDate) => {
    let controller = new AbortController();
    let signal = controller.signal;

    let payload = {};
    if (careUnitIds.length) {
      payload['care_unit_ids'] = careUnitIds;
    }

    let promiseStats = AllStats(startDate, endDate, payload, signal);
    promiseStats.cancel = () => controller.abort();

    return promiseStats;
  };

  /**
   *
   * @param {*} newDate
   */
  const loadStatsByMouth = (newDate) => {
    const { startDate, endDate } = getDatesMonth(newDate);
    loadStats(startDate, endDate);
  };

  /**
   *
   * @param {*} cell
   */
  const dateCellRender = (cell) => {
    let statsFound = null;
    stats.map((statsOfDay) => {
      if (statsOfDay['date'] === cell.format('YYYYMMDD')) {
        statsFound = statsOfDay;
      }

      return statsOfDay;
    });

    let classCapacity = ["ant-picker-capacity", "row-data"];

    if (statsFound !== null) {
      classCapacity.push(statsFound['className']);
    }

    if (!!selectedDate && selectedDate.format('YYYYMMDD') === cell.format('YYYYMMDD')) {
      classCapacity.push("ant-picker-selected");
    }

    return (<div className={classCapacity.join(' ')}>{cell.format('D')}</div>)
  }

  /**
   *
   * @param {*} newDate
   */
  const onSelect = (newDate) => {
    props.selectDate(newDate);
  };

  /**
   *
   */
  const onClickPrevMonthHandler = () => {
    let day = selectedDate.clone().format('DD');
    let newDate = selectedDate.clone().subtract(1, 'months').set(day, 'date');
    onSelect(newDate);
  }

  /**
   *
   */
  const onClickNextMonthHandler = () => {
    let day = selectedDate.clone().format('DD');
    let newDate = selectedDate.clone().add(1, 'months').set(day, 'date');
    onSelect(newDate);
  }

  /**
   *
   */
  const reload = () => {
    loadStatsByMouth(selectedDate);
  }

  useImperativeHandle(ref, () => ({
    reload: () => {
      reload();
    },
  }));

  useEffect(() => {
    loadStatsByMouth(selectedDate);
  }, [selectedDate, careUnitIds]);

  return (
    <>
      <Space
        style={{
          padding: "8px",
          width: "100%",
          position: "absolute",
          zIndex: 1,
        }}
      >
        <Button
          type="primary"
          shape="circle"
          icon={<LeftOutlined />}
          onClick={onClickPrevMonthHandler}
        />
        <Button
          type="primary"
          shape="circle"
          icon={<RightOutlined />}
          onClick={onClickNextMonthHandler}
        />
      </Space>
      <Spin spinning={loading}>
        <Calendar
          fullscreen={false}
          value={selectedDate}
          onSelect={onSelect}
          dateFullCellRender={dateCellRender}
          onPanelChange={() => {}}
        />
      </Spin>
    </>
  );
});

export default MonthTab;
